/**
 * Lazy-load Gravity Forms core scripts.
 *
 * The PHP side (inc/filters/lazy-load-gravityforms.php) strips the Gravity
 * Forms <script src> tags and hands us their URLs. We inject them on the first
 * real user interaction or as soon as a form scrolls into view. Gravity Forms'
 * inline bootstrap queues every initializeOnLoaded() callback until the files
 * dispatch their *_scripts_loaded events, so once the files execute the forms
 * render themselves - no manual gform_post_render needed.
 */
(function () {
    const config = window.dlGformLazy;

    if (!config || !Array.isArray(config.scripts) || config.scripts.length === 0) {
        return;
    }

    const INTERACTION_EVENTS = ['pointerdown', 'mousedown', 'keydown', 'touchstart'];
    const FORM_SELECTOR = 'form[id^="gform_"], .gform_wrapper, [data-js-turnstile]';

    let loaded = false;
    let observer = null;

    function loadScripts() {
        if (loaded) {
            return;
        }
        loaded = true;

        // async = false keeps execution order, mirroring the original `defer`.
        config.scripts.forEach((src) => {
            if (document.querySelector(`script[src="${src}"]`)) {
                return;
            }

            const script = document.createElement('script');
            script.src = src;
            script.async = false;
            document.body.appendChild(script);
        });

        teardown();
    }

    function teardown() {
        INTERACTION_EVENTS.forEach((event) => {
            window.removeEventListener(event, loadScripts, true);
        });

        if (observer) {
            observer.disconnect();
            observer = null;
        }
    }

    function bindInteraction() {
        INTERACTION_EVENTS.forEach((event) => {
            window.addEventListener(event, loadScripts, { capture: true, passive: true });
        });
    }

    function observeForms() {
        if (!('IntersectionObserver' in window)) {
            return;
        }

        observer = new IntersectionObserver((entries) => {
            for (const entry of entries) {
                if (entry.isIntersecting) {
                    loadScripts();
                    return;
                }
            }
        }, { rootMargin: '200px' });

        document.querySelectorAll(FORM_SELECTOR).forEach((form) => observer.observe(form));
    }

    function init() {
        bindInteraction();
        observeForms();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
